import { useLocation } from 'react-router';
import { SKIN_CONFIGS, shouldShowBetslipForPath } from '../config/skinRegistry/configs';
import { useSkinConfigs } from './useSkinConfigs';

const useShouldShowBetslip = () => {
  const { pathname } = useLocation();
  const { layout } = useSkinConfigs(SKIN_CONFIGS);
  return shouldShowBetslipForPath({ pathname, layout });
};

export default useShouldShowBetslip;
